import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Button,
  Paper,
  FormHelperText,
  FormLabel,
  Typography,
} from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { kmMessages, getSystemLabel } from "src/constant/Messages";
import MUIRichTextEditor from "mui-rte";
import { DropzoneAreaBase } from "material-ui-dropzone";
import { stateToHTML } from "draft-js-export-html";
import TableContainer from "@material-ui/core/TableContainer";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import KmFormEditTable from "src/components/common/KmFormEditTable";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Skeleton from "@material-ui/lab/Skeleton";
import SendIcon from "@material-ui/icons/Send";
import SaveIcon from "@material-ui/icons/Save";
import { convertToRaw } from "draft-js";
import { stateFromHTML } from "draft-js-import-html";
import { fillMissingTags, cutTextIfTooLong } from "src/utils/utils";
import { connect } from "react-redux";

const subjectMaxLength = 500;
const addemailsMaxLength = 500;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}`,
  validate: `${kmMessages.error.form_validation.field_wronginputformat}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  rtepaper: {
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  rtecontroll: {
    "& > ol": {
      paddingLeft: theme.spacing(4),
    },
  },
  attachmentdialog: {
    minWidth: 500,
  },
  img: {
    margin: "auto",
    display: "block",
    maxHeight: 60,
    maxWidth: "auto",
  },
  addresscard: {
    padding: theme.spacing(1),
  },
}));

const attachmentCols = [
  {
    label: "L.p.",
    isLp: true,
    isEditable: false,
    width: "5%",
  },
  {
    label: "Typ",
    fieldName: "type",
    isEditable: false,
    width: "5%",
  },
  {
    label: "Nazwa",
    fieldName: "name",
    isEditable: false,
    width: "40%",
  },
  {
    label: "Plik/Odnośnik",
    fieldName: "details",
    isEditable: false,
    width: "40%",
    isHtml: true,
  },
];

const Form = ({
  globalData,
  systemInfo,
  onSubmit,
  folderId,
  massageTypes,
  profiles,
  institutions,
  workingGroups,
  functions,
  voting,
  votingMessageType,
  news,
  newsMessageType,
  dictionairesLoaded,
  ...rest
}) => {
  const classes = useStyles();

  const [nextSubmitTry, setNextSubmitTry] = useState(false);
  const [contentValue, setContentValue] = useState(null);
  const [htmlContentValue, setHtmlContentValue] = useState("");
  const [contentEmpty, setContentEmpty] = useState(true);

  const [images, setImages] = useState([]);
  const [attachments, setAttachments] = useState([]);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [selectedInstitutions, setSelectedInstitutions] = useState([]);
  const [selectedFunctions, setSelectedFunctions] = useState([]);
  const [selectedWorkingGroups, setSelectedWorkingGroups] = useState([]);
  const [mailingStatus, setMailingStatus] = useState();

  const { handleSubmit, setValue, control, errors } = useForm();

  useEffect(() => {
    if (news) {
      let newsDefaultContentHtml = `<p>Szanowni Państwo,</p><p>Zachęcamy do zapoznania się z artykułem <b>${news.title}</b></p>`;
      if (systemInfo?.systemHostName && news?.id) {
        let newUrl = `${systemInfo.systemHostName}/aktualnosci/artykul/${news.id}`;
        newsDefaultContentHtml += `<p>Artykuł został opublikowany na Portalu KM ${getSystemLabel(
          "programShortcut",
          globalData.systemInfo
        )} pod adresem <a href="${newUrl}">${newUrl}</a></p>`;
      }
      newsDefaultContentHtml += `<p>Z poważaniem</p>`;

      let contentState = stateFromHTML(newsDefaultContentHtml);
      setContentValue(JSON.stringify(convertToRaw(contentState)));
    }
    return () => {};
  }, [news]);

  useEffect(() => {
    if (voting) {
      let votingDefaultContentHtml = `<p>Szanowni Państwo,</p><p>Przypominamy, że dzisiaj kończy się głosowanie `;
      if (systemInfo?.systemHostName && voting?.id) {
        let votingUrl = `${systemInfo.systemHostName}/glosowanie/${voting.id}`;
        votingDefaultContentHtml += `<a href="${votingUrl}">${cutTextIfTooLong(
          voting.title,
          200
        )}</a></p>`;
      }
      votingDefaultContentHtml +=
        systemInfo?.fundProgram === "fedp2127"
          ? `<p>Uprzejmie prosimy osoby, które jeszcze się nie wzięły udziału w głosowaniu, o oddanie głosu. Jeżeli nie uzyskamy wymaganej liczby głosów, tj. połowy liczby uprawnionych do głosowania osób, głosowanie zostanie uznane za nieważne.</p>`
          : `<p>Uprzejmie prosimy osoby, które jeszcze się nie wzięły udziału w głosowaniu, o oddanie głosu. Jeżeli nie uzyskamy wymaganej liczby głosów, tj. jednej trzeciej liczby uprawnionych do głosowania osób, głosowanie zostanie uznane za nieważne.</p>`;

      votingDefaultContentHtml += `<p>Z poważaniem</p>`;

      let contentState = stateFromHTML(votingDefaultContentHtml);
      setContentValue(JSON.stringify(convertToRaw(contentState)));
    }
    return () => {};
  }, [voting]);

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);

  const handleContentChange = (event) => {
    let htmlState = stateToHTML(event.getCurrentContent());

    setContentEmpty(!event.getCurrentContent().hasText());

    setHtmlContentValue(htmlState);
  };

  const validateEmail = (email) => {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const onFormSubmit = (values) => {
    if (!contentEmpty) {
      setContentEmpty(false);
      onSubmit(
        values,
        htmlContentValue,
        selectedFunctions,
        selectedInstitutions,
        selectedWorkingGroups,
        selectedProfiles,
        attachments,
        mailingStatus
      );
    } else {
      setContentEmpty(true);
      setNextSubmitTry(true);
    }
  };

  const onWorkingGroupChange = (e, data) => {
    e.preventDefault();
    setSelectedWorkingGroups(data);
  };

  const onProfilesChange = (e, data) => {
    e.preventDefault();
    setSelectedProfiles(data);
  };

  const onInstitutionsChange = (e, data) => {
    e.preventDefault();
    setSelectedInstitutions(data);
  };

  const onFunctionsChange = (e, data) => {
    e.preventDefault();
    setSelectedFunctions(data);
  };

  const handleAttachmentsAdd = (newFiles) => {
    newFiles = newFiles.filter(
      (file) => !attachments.find((f) => f.resName === file.file.name)
    );

    let newAttachments = newFiles.map((file, index) => {
      return {
        id: `${new Date().getTime()}${index}`,
        type: <InsertDriveFileIcon />,
        attachmentType: "file",
        fileData: file,
        name: file.file.name,
        resName: file.file.name,
        details: file.file.name,
      };
    });

    setAttachments([...attachments, ...newAttachments]);
  };

  const handleMessageTypeChange = (origChange, data) => {
    setContentValue(null);
    setValue("subject", null);

    if (data?.messageTag) {
      switch (data.messageTag) {
        case "invitation":
          var defaultContentHtml = `<p>Szanowni Państwo,</p><p></p><p>Zapraszamy na <b>... posiedzenie Komitetu Monitorującego ${getSystemLabel(
            "programYears",
            globalData.systemInfo
          )}</b>, które odbędzie się ...</p>`;
          defaultContentHtml += `<p>Spotkanie rozpocznie się o godz. ...</p>`;

          if (systemInfo?.systemHostName && folderId) {
            let docUrl = `${systemInfo.systemHostName}/dokumenty/${folderId}`;
            defaultContentHtml += `<p>Dokumenty dostępne pod adresem: <a href="${docUrl}">${docUrl}</a> - <b>uwagi proszę przesyłać do Sekretariatu Komitetu do dnia ... r.</b></p>`;
          }
          defaultContentHtml +=
            "<p>Aby potwierdzić udział, proszę kliknąć w link: ${udzial}</p>";
          defaultContentHtml +=
            "<p>Aby potwierdzić brak udziału, proszę kliknąć w link: ${brakudzialu}</p>";
          defaultContentHtml += `<p>Z poważaniem</p>`;

          var contentState = stateFromHTML(defaultContentHtml);
          setContentValue(JSON.stringify(convertToRaw(contentState)));
          setValue(
            "subject",
            `Zaproszenie na ... posiedzenie KM ${getSystemLabel(
              "programShortcut",
              globalData.systemInfo
            )}`
          );

          break;
        case "meeting_materials":
          defaultContentHtml = `<p>Szanowni Państwo,</p>`;
          defaultContentHtml += `<p>Informujemy, że na portalu Komitetu pod adresem: `;

          if (systemInfo?.systemHostName && folderId) {
            let docUrl = `${systemInfo.systemHostName}/dokumenty/${folderId}`;
            defaultContentHtml += `<a href="${docUrl}">${docUrl} </a> `;
          }

          defaultContentHtml += `dostępne są materiały pod obrady zbliżającego się ... posiedzenia Komitetu Monitorującego ${getSystemLabel(
            "programShortcut",
            globalData.systemInfo
          )}.</p>`;
          defaultContentHtml +=
            "<p>Uwagi do materiałów proszę przesyłać do Sekretariatu Komitetu do dnia <b>... r.</b></p>";
          defaultContentHtml += `<p>Z poważaniem</p>`;

          contentState = stateFromHTML(defaultContentHtml);
          setContentValue(JSON.stringify(convertToRaw(contentState)));
          setValue(
            "subject",
            `Materiały na ... posiedzenie KM ${getSystemLabel(
              "programShortcut",
              globalData.systemInfo
            )}`
          );

          break;
        case "circ_mode":
          defaultContentHtml = `<p>Szanowni Państwo,</p>`;
          defaultContentHtml += `<p>przesyłamy informację o trybie obiegowym do przyjęcia Uchwały ...</p>`;

          defaultContentHtml += `<p>Niezbędna dokumentacja w tym zakresie znajduje się na `;

          if (systemInfo?.systemHostName && folderId) {
            let docUrl = `${systemInfo.systemHostName}/dokumenty/${folderId}`;
            defaultContentHtml += `<a href="${docUrl}">portalu KM ${getSystemLabel(
              "programShortcut",
              globalData.systemInfo
            )}. </a> `;
          }
          defaultContentHtml += `</p>`;

          defaultContentHtml += `<p>Uwagi do zapisów dokumentu proszę kierować do <u>Sekretariatu KM ${getSystemLabel(
            "programShortcut",
            globalData.systemInfo
          )}</u> do dnia <b>... r.</b></p>`;

          defaultContentHtml +=
            "<p>Po tym terminie uchwała zostanie poddana głosowaniu, o czym zostaną Państwo poinformowani odrębnym mailem. </p>";

          defaultContentHtml += `<p>Z poważaniem</p>`;

          contentState = stateFromHTML(defaultContentHtml);
          setContentValue(JSON.stringify(convertToRaw(contentState)));
          setValue("subject", "Tryb obiegowy - ...");

          break;
        case "materials":
          defaultContentHtml = `<p>Szanowni Państwo,</p>`;
          defaultContentHtml += `<p>Informujemy, że na portalu Komitetu pod adresem: `;

          if (systemInfo?.systemHostName && folderId) {
            let docUrl = `${systemInfo.systemHostName}/dokumenty/${folderId}`;
            defaultContentHtml += `<a href="${docUrl}">${docUrl}</a> `;
          }
          defaultContentHtml += `dostępne są materiały dotyczące ...</p>`;

          defaultContentHtml += "<p>Zachęcamy do zapoznania się.</p>";

          defaultContentHtml += `<p>Z poważaniem</p>`;

          contentState = stateFromHTML(defaultContentHtml);
          setContentValue(JSON.stringify(convertToRaw(contentState)));

          break;
        case "szoop":
          defaultContentHtml = `<p>Szanowni Państwo,</p>`;
          defaultContentHtml += `<p>Informujemy, że Uchwałą Nr ... Zarządu Województwa Podlaskiego z dnia ... r. zmieniony został  Szczegółowy Opis Osi Priorytetowych ${getSystemLabel(
            "programYearsGo",
            globalData.systemInfo
          )}. Aktualna wersja dokumentu została opublikowana na stronie internetowej Instytucji Zarządzającej ${getSystemLabel(
            "programYearsYm",
            globalData.systemInfo
          )} <a href="https://rpo.wrotapodlasia.pl">rpo.wrotapodlasia.pl</a> oraz na Portalu Funduszy Europejskich <a href="https://www.funduszeeuropejskie.gov.pl">www.funduszeeuropejskie.gov.pl</a>, a także znajduje się na `;

          if (systemInfo?.systemHostName && folderId) {
            let docUrl = `${systemInfo.systemHostName}/dokumenty/${folderId}`;
            defaultContentHtml += `<a href="${docUrl}">portalu KM ${getSystemLabel(
              "programShortcut",
              globalData.systemInfo
            )}</a> `;
          }
          defaultContentHtml += `.</p>`;

          defaultContentHtml += `<p>Z poważaniem</p>`;

          contentState = stateFromHTML(defaultContentHtml);
          setContentValue(JSON.stringify(convertToRaw(contentState)));
          setValue(
            "subject",
            `Szczegółowy Opis Osi Priorytetowych ${getSystemLabel(
              "programShortcut",
              globalData.systemInfo
            )}`
          );

          break;
        case "proj_protocol":
          defaultContentHtml = `<p>Szanowni Państwo,</p>`;
          defaultContentHtml += `<p>Informujemy, że na `;

          if (systemInfo?.systemHostName && folderId) {
            let docUrl = `${systemInfo.systemHostName}/dokumenty/${folderId}`;
            defaultContentHtml += `<a href="${docUrl}">portalu KM ${getSystemLabel(
              "programShortcut",
              globalData.systemInfo
            )}</a> `;
          }
          defaultContentHtml += `znajduje się <b>projekt protokołu</b> z ... posiedzenia Komitetu Monitorującego ${getSystemLabel(
            "programYears",
            globalData.systemInfo
          )} z dn. ... r.</p>`;

          defaultContentHtml += `<p>Ewentualne uwagi do jego zapisów proszę przesyłać na adres `;

          if (systemInfo?.kmEmail) {
            let emailMailto = `mailto:${systemInfo.kmEmail}`;
            defaultContentHtml += `<a href="${emailMailto}">Sekretariatu Komitetu</a> `;
          }

          defaultContentHtml += `do ... r.</p>`;

          defaultContentHtml += `<p>Z poważaniem</p>`;

          contentState = stateFromHTML(defaultContentHtml);
          setContentValue(JSON.stringify(convertToRaw(contentState)));
          setValue(
            "subject",
            `Projekt protokołu z ... posiedzenia KM ${getSystemLabel(
              "programShortcut",
              globalData.systemInfo
            )}`
          );

          break;
        default:
          break;
      }
    }

    origChange(data);
  };

  return (
    <Card className={clsx(classes.root)}>
      <Box component="main">
        <Grid container className={classes.root}>
          <Grid item xs={12} elevation={2}>
            <form onSubmit={handleSubmit(onFormSubmit)}>
              <FormControl fullWidth className={classes.formcontrol}>
                {dictionairesLoaded ? (
                  voting && votingMessageType ? (
                    <Box>
                      <FormLabel>Rodzaj wiadomości</FormLabel>
                      <Typography>{votingMessageType.name}</Typography>
                    </Box>
                  ) : news && newsMessageType ? (
                    <Box>
                      <FormLabel>Rodzaj wiadomości</FormLabel>
                      <Typography>{newsMessageType.name}</Typography>
                    </Box>
                  ) : (
                    <Box>
                      <Controller
                        render={({ onChange, ...props }) => (
                          <Autocomplete
                            id="message-type-id"
                            options={massageTypes}
                            getOptionLabel={(option) => option.name}
                            getOptionSelected={(option, value) =>
                              value && option.id === value.id
                            }
                            value={props.value}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={errors.messageType ? true : false}
                                label="Rodzaj wiadomości"
                                placeholder="Rodzaj wiadomości"
                                helperText={
                                  errors.messageType &&
                                  (formValidation[errors.messageType.type] ||
                                    "")
                                }
                              />
                            )}
                            onChange={(e, data) =>
                              handleMessageTypeChange(onChange, data)
                            }
                          />
                        )}
                        onChange={([, data]) => data}
                        name="messageType"
                        control={control}
                        rules={{ required: true }}
                      />
                    </Box>
                  )
                ) : (
                  <Skeleton />
                )}
              </FormControl>

              <Card className={classes.addresscard}>
                <FormLabel className={classes.paddingBottom} component="label">
                  Adresaci wiadomości:
                </FormLabel>
                <FormControl fullWidth className={classes.formcontrol}>
                  {dictionairesLoaded ? (
                    <Autocomplete
                      multiple
                      id="profiles-id"
                      options={profiles}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        value && option.id === value.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Profile użytkownika"
                          placeholder="Profile użytkownika"
                        />
                      )}
                      onChange={onProfilesChange}
                    />
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>

                <FormControl fullWidth className={classes.formcontrol}>
                  {dictionairesLoaded ? (
                    <Autocomplete
                      multiple
                      id="institutions-id"
                      options={institutions}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        value && option.id === value.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Instytucje"
                          placeholder="Instytucje"
                        />
                      )}
                      onChange={onInstitutionsChange}
                    />
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  {dictionairesLoaded ? (
                    <Autocomplete
                      multiple
                      id="functions-id"
                      options={functions}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        value && option.id === value.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Funkcje"
                          placeholder="Funkcje"
                        />
                      )}
                      onChange={onFunctionsChange}
                    />
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  {dictionairesLoaded ? (
                    <Autocomplete
                      multiple
                      id="workinggroups-id"
                      options={workingGroups}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        value && option.id === value.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Grupy robocze"
                          placeholder="Grupy robocze"
                        />
                      )}
                      onChange={onWorkingGroupChange}
                    />
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
                <FormControl fullWidth className={classes.formcontrol}>
                  {dictionairesLoaded ? (
                    <Controller
                      as={
                        <TextField
                          error={errors.customEmails ? true : false}
                          id="customEmails"
                          name="customEmails"
                          label="Dodatkowi adresaci (adresy e-mail oddzielone przecinkiem)"
                          placeholder="Dodatkowi adresaci (adresy e-mail oddzielone przecinkiem)"
                          multiline
                          helperText={
                            errors.customEmails &&
                            (
                              formValidation[errors.customEmails.type] || ""
                            ).replaceAll("{maxlen}", addemailsMaxLength)
                          }
                        />
                      }
                      name="customEmails"
                      control={control}
                      rules={{
                        required: false,
                        maxLength: addemailsMaxLength,
                        validate: (value) => {
                          let validList = true;

                          if (value) {
                            let emails = value?.split(",");
                            console.log(emails);
                            emails?.forEach((email) => {
                              email = email.replace(/\s/g, "");
                              if (!validateEmail(email)) {
                                console.log("email not valid");
                                validList = false;
                              }
                            });
                            console.log("email not sssvalid");
                          }

                          return validList;
                        },
                      }}
                    />
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
              </Card>
              <FormControl fullWidth className={classes.formcontrol}>
                {dictionairesLoaded ? (
                  <Controller
                    as={
                      <TextField
                        error={errors.subject ? true : false}
                        id="subject"
                        name="subject"
                        label="Temat wiadomości"
                        placeholder="Temat wiadomości"
                        multiline
                        helperText={
                          errors.title &&
                          (
                            formValidation[errors.subject.type] || ""
                          ).replaceAll("{maxlen}", subjectMaxLength)
                        }
                      />
                    }
                    name="subject"
                    defaultValue={
                      voting
                        ? "Przypomnienie-GŁOSOWANIE"
                        : news
                        ? news.title
                        : ""
                    }
                    control={control}
                    rules={{ required: true, maxLength: subjectMaxLength }}
                  />
                ) : (
                  <Skeleton />
                )}
              </FormControl>
              <FormControl
                fullWidth
                className={classes.formcontrol}
                variant="outlined"
              >
                <Box className={classes.paddingbottom}>
                  <FormLabel for="newscontentrte">Treść wiadomości:</FormLabel>
                </Box>
                {dictionairesLoaded ? (
                  <Paper variant="outlined" className={classes.rtepaper}>
                    <MUIRichTextEditor
                      label="Wprowadź treść wiadomości"
                      defaultValue={contentValue}
                      className={classes.rtecontroll}
                      id="newscontentrte"
                      controls={[
                        "title",
                        "bold",
                        "italic",
                        "underline",
                        "strikethrough",
                        "highlight",
                        "undo",
                        "redo",
                        "link",
                        "media",
                        "numberList",
                        "bulletList",
                        "quote",
                        "clear",
                      ]}
                      onChange={handleContentChange}
                      inlineToolbar={true}
                    />
                  </Paper>
                ) : (
                  <Skeleton />
                )}
                {nextSubmitTry && contentEmpty ? (
                  <FormHelperText id="mailing-content-helper" error>
                    {formValidation.required}
                  </FormHelperText>
                ) : (
                  <></>
                )}
              </FormControl>
              <FormControl component="fieldset" className={classes.formcontrol}>
                <FormLabel component="legend">Stopka:</FormLabel>
                <Controller
                  as={
                    <RadioGroup row aria-label="Stopka" name="footer">
                      <FormControlLabel
                        value="nofooter"
                        control={<Radio color="primary" />}
                        label="brak"
                      />
                      <FormControlLabel
                        value="notification_messages"
                        control={<Radio color="primary" />}
                        label="stopka powiadomień"
                      />
                      <FormControlLabel
                        value="system_messages"
                        control={<Radio color="primary" />}
                        label="stopka wiadomości systemowych"
                      />
                    </RadioGroup>
                  }
                  name="footer"
                  defaultValue="nofooter"
                  control={control}
                  rules={{ required: true }}
                />
              </FormControl>

              {dictionairesLoaded ? (
                <FormControl
                  fullWidth
                  className={classes.formcontrol}
                  variant="outlined"
                  label="Załączniki"
                >
                  <Box className={classes.paddingbottom}>
                    <FormLabel for="attachmentsfileupload">
                      Załączniki:
                    </FormLabel>
                  </Box>
                  <DropzoneAreaBase
                    showAlerts={false}
                    name="attachmentsfileupload"
                    className={classes.fileUpload}
                    previewText="Wybrane pliki:"
                    filesLimit={3}
                    maxFileSize={10485760}
                    dropzoneText="Przeciągnij i upuść pliki lub kliknij"
                    inputProps={{
                      title: "Dodaj pliki",
                      id: "attachmentsfileupload",
                    }}
                    showPreviews={false}
                    showPreviewsInDropzone={false}
                    showFileNamesInPreview={false}
                    onAdd={handleAttachmentsAdd}
                  />

                  <TableContainer component={Paper}>
                    <KmFormEditTable
                      columns={attachmentCols}
                      rows={attachments}
                      caption="Załączniki"
                      setRows={setAttachments}
                      editable={false}
                    />
                  </TableContainer>
                </FormControl>
              ) : (
                <Skeleton />
              )}

              <Box className={classes.paddingtop}>
                <Button
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={
                    voting
                      ? "/zarzadzanieglosowania/wtrakcie"
                      : news
                      ? "/aktualnosci/opublikowane"
                      : `/dokumenty/${folderId}`
                  }
                >
                  Anuluj
                </Button>
                <Button
                  disabled={!dictionairesLoaded}
                  color="primary"
                  variant="contained"
                  className={classes.button}
                  endIcon={<SaveIcon />}
                  onClick={() => setMailingStatus("draft")}
                  type="submit"
                >
                  Zapisz
                </Button>
                <Button
                  disabled={!dictionairesLoaded}
                  color="primary"
                  variant="contained"
                  className={classes.button}
                  endIcon={<SendIcon />}
                  onClick={() => setMailingStatus("pending")}
                  type="submit"
                >
                  Wyślij
                </Button>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

export default connect(mapStateToProps, null)(Form);
